<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <form @submit.prevent="upload">
      <div class="modal-header">
        <header class="text-center pb-4 border-b border-grey">
          <h3
            class="mt-0 font-bold"
            v-text="'Upload a CSV of Membership Data'"
          />
        </header>
      </div>
      <div class="modal-body mb-8">
        <div class="field">
          <input
            id="csvFile"
            ref="csvFile"
            type="file"
            name="csvFile"
          >
        </div>
        <div class="field">
          <input
            id="hasHeaders"
            v-model="hasHeaders"
            type="checkbox"
            name="hasHeaders"
          >
          <label
            for="hasHeaders"
            v-text="'File contains header row'"
          />
        </div>
      </div>
      <div class="modal-footer text-center mt-4">
        <button
          class="btn"
          type="submit"
          v-text="'Upload'"
        />
        <a
          href="#"
          class="mx-4"
          @click.prevent="close"
          v-text="'Cancel'"
        />
      </div>
    </form>
  </BaseModal>
</template>

<script type="text/babel">
export default {
  name: 'UploadMemberCSVModal',
  data() {
    return {
      hasHeaders: false,
    }
  },
  computed: {
    show() {
      return this.$store.state.membership.uploadMemberCSVModal.open
    },
  },
  methods: {
    gatherFormData() {
      const data = new FormData()

      data.append('csv_file', this.$refs.csvFile.files[0])

      if (this.hasHeaders) {
        data.append('header', '1')
      }

      return data
    },
    upload() {
      this.$api.active().post('/memberships/imports', this.gatherFormData())
        .then((response) => {
          window.location = this.$urlGenerator.active(`members/imports/${response.data.meta.uuid}/map-columns`)
        }).catch((errors) => {
          this.$store.commit('baseAddNotification', {
            title: 'Error!',
            text: errors.response.data.message,
            type: 'error',
          })

          this.close()
        })
    },
    close() {
      this.$store.commit('membershipCloseUploadMemberCSVModal')
    },
  },
}
</script>
